<template>
  <validation-provider
    tag="div"
    name="address"
    :rules="rules"
    mode="passive"
    v-slot="{ errors }"
  >
    <form-label for="address">
      Address
      <span class="leading-none text-red-400">*</span>
    </form-label>
    <form-input
      id="address"
      :placeholder="placeholder"
      v-model="internalValue"
      @input="onInput"
    ></form-input>
    <form-alert-msg v-if="errors[0]">{{ errors[0] }}</form-alert-msg>
  </validation-provider>
</template>

<script>
import { FormInput, FormLabel, FormAlertMsg } from "@/components/Form/";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", { ...required, message: "This field is required." });

export default {
  components: {
    ValidationProvider,
    FormInput,
    FormLabel,
    FormAlertMsg,
  },
  props: ["value", "controls"],
  data() {
    return {
      internalValue: "",
    };
  },
  computed: {
    placeholder() {
      if (this.controls?.scheduling_for === "someone-else") {
        return "Enter patient's address";
      }
      return "Enter your address";
    },
    rules() {
      return "required";
    },
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>
